import React from "react";
import { Route, Routes } from "react-router-dom";
import LandingPage from "./components/LandingPage/LandingPage";
import BasicInformation from "./components/BasicInformation/BasicInformation";
import IndividualMedical from "./components/Plans/IndividualMedical";
import GreenPlan from "./components/Plans/GreenPlan/GreenPlan";
import ThanksQuestion from "./components/Questions/ThanksQuestion/ThanksQuestion";
import HealthQuestions from "./components/Questions/HealthQuestions/HealthQuestions";
import ContainerLayout from "./components/Layout/ContainerLayout";
import Footer from "./components/Footer/Footer";
import Summary from "./components/Summary/Summary";
import PaymentDetails from "./components/PaymentDetails/PaymentDetails";
import UploadDocument from "./components/UploadDocument/UploadDocument";
import PaymentSuccessful from "./components/PaymentDetails/PaymentSuccessful";
import PaymentUnSuccessful from "./components/PaymentDetails/PaymentUnSuccessful";
import UnifiedHealthInsurancePlan from "./components/UnifiedHealthInsurancePlan/UnifiedHealthInsurancePlan";
import AffordableHealthPlan from "./components/Plans/AffordableHealthPlan/AffordableHealthPlan";
import PersonalInformation from "./components/PersonalInformation/PersonalInformation";
import UnifiedDomesticWorker from "./components/Plans/UnifiedDomesticWorker/UnifiedDomesticWorker";
import ScrollToTop from "./ScrollToTop";
import ChoosePlan from "./components/ChoosePlan/ChoosePlan";
import { useEffect } from "react";

function HistoryBlocker() {
  useEffect(() => {
    let backButtonPressed = false;
    window.history.pushState(null, null, window.location.href);

    const handlePopState = () => {
      backButtonPressed = true;
      window.history.pushState(null, null, window.location.href);
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  return null;
}


function RouteConfig() {
  return (
    <>
      <HistoryBlocker />
      <ScrollToTop /> 
      <Routes>
        {/* <Route path="/" element={<Navigate to="/medical-insurance"/>} /> */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/payment-result" element={<ContainerLayout showHeader={false}><PaymentSuccessful /></ContainerLayout>} />
        <Route path="/payment-error" element={<ContainerLayout showHeader={false}><PaymentUnSuccessful /></ContainerLayout>} />
        <Route path="/coming-soon" element={<UnifiedHealthInsurancePlan />} />

        <Route
          path="/choose-your-plan"
          backTo="/"
          element={
            <ContainerLayout bgImage="bg-image-life" backTo="/">
              <ChoosePlan />
            </ContainerLayout>
          }
        />
        <Route
          path="/basic-information"
          element={
            <ContainerLayout
              bgImage="bg-image-medical"
              backTo="/choose-your-product"
              stepNo={1}
              totalSteps={4}
            >
              <BasicInformation />
            </ContainerLayout>
          }
        /> 
        {/* <Route
          path="/personal-information"
          element={<ContainerLayout bgImage="bg-image-health" stepNo={2} totalSteps={3}><PersonalInformation /></ContainerLayout>}
        /> */}
        <Route
          path="/plan"
          element={
            <ContainerLayout
              bgImage="bg-image-medical"
              backTo="/basic-information"
              stepNo={1}
              totalSteps={4}
            >
              <GreenPlan />
            </ContainerLayout>
          }
        />
        <Route
          path="/thanks-question"
          element={<ContainerLayout bgImage="bg-image-medical"><ThanksQuestion /></ContainerLayout>}
        />
        <Route
          path="/question/health"
          element={
            <ContainerLayout
              bgImage="bg-image-medical"
              backTo="/personal-information"
              stepNo={3}
              totalSteps={4}
            >
              <HealthQuestions />
            </ContainerLayout>
          }
        />
        <Route
          path="/summary"
          element={
            <ContainerLayout
              backTo="/question/health"
              stepNo={4}
              totalSteps={4}
            >
              <Summary />
            </ContainerLayout>
          }
        />
         <Route
          path="/payment-details"
          element={<ContainerLayout bgImage="bg-image-medical" backTo="/summary"><PaymentDetails /></ContainerLayout>}
        />
        <Route
          path="/upload"
          element={
            <ContainerLayout
              bgImage="bg-image-medical"
              backTo="/question/health"
              stepNo={3}
              totalSteps={4}
            >
              <UploadDocument />
            </ContainerLayout>
          }
        />
        <Route
          path="/plans/health/affordable-health-cover-plan"
          element={
            <ContainerLayout
              bgImage="bg-image-medical"
              backTo="/basic-information"
              stepNo={1}
              totalSteps={4}
            >
              <AffordableHealthPlan />
            </ContainerLayout>
          }
        />
        <Route
          path="/personal-information"
          element={
            <ContainerLayout
              bgImage="bg-image-medical"
              backTo="/basic-information"
              stepNo={2}
              totalSteps={4}
            >
              <PersonalInformation />
            </ContainerLayout>
          }
        />
        <Route
          path="/plans/health/unified-domestic-worker"
          element={
            <ContainerLayout
              bgImage="bg-image-medical"
              backTo="/basic-information"
              stepNo={1}
              totalSteps={4}
            >
              <UnifiedDomesticWorker />
            </ContainerLayout>
          }
        />
      </Routes>
      {/* <Footer /> */}
    </>
  );
}

export default RouteConfig;
